'use client';

import { Anchor, Box, Group, Text, useMantineTheme } from '@mantine/core';
import { useEffect, useState } from 'react';
import { getSystemYear } from '../../../lib/api/system-client';
import { useStableColorScheme } from '../../../lib/use-stable-color-scheme';

interface FooterProps {
  withinAppShell?: boolean;
}

export default function Footer({ withinAppShell = false }: FooterProps) {
  const theme = useMantineTheme();
  const colorScheme = useStableColorScheme();
  const footerColor = colorScheme === 'dark' ? theme.other.footerColorDark : theme.other.footerColorLight;
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const fetchYear = async () => {
      const systemYear = await getSystemYear();

      if (typeof systemYear === 'number') {
        setYear(systemYear);
        return;
      }

      setYear(new Date().getFullYear());
    };

    void fetchYear();
  }, []);

  return (
    <Box
      // При `withinAppShell` (NAV-CONT-D-002) Footer рендерится ВНУТРИ `AppShell.Footer`,
      // который уже даёт `<footer>` (role=contentinfo). Чтобы не плодить дублирующий
      // landmark (ARIA: 2× contentinfo — strict-mode violation в `getByRole('contentinfo')`,
      // контракт §13.3 AC #4), рендерим обёртку без footer-role; landmark'ом служит
      // AppShell.Footer. На welcome-странице (без AppShell) Footer.tsx сам даёт `<footer>`.
      component={withinAppShell ? 'div' : 'footer'}
      bg={footerColor}
      style={{
        borderTop: `1px solid ${colorScheme === 'dark' ? 'rgba(167, 139, 250, 0.18)' : 'rgba(123, 77, 255, 0.12)'}`,
        backdropFilter: 'blur(14px)',
        height: withinAppShell ? '100%' : undefined,
      }}
    >
      <Group
        justify="center"
        align="center"
        gap="md"
        wrap="wrap"
        mih={theme.other.footerHeight}
        px={{ base: 'md', sm: 'xl' }}
        py="sm"
      >
        <Text size="sm" c="dimmed">
          © {year} Синтра. Корпоративный портал.
        </Text>

        <Group gap="lg" wrap="wrap" align="center">
          <Anchor href="#" size="sm" c="dimmed">
            Поддержка
          </Anchor>
          <Anchor href="#" size="sm" c="dimmed">
            Конфиденциальность
          </Anchor>
          <Anchor href="#" size="sm" c="dimmed">
            Условия использования
          </Anchor>
        </Group>
      </Group>
    </Box>
  );
}
